import algoliasearch from 'algoliasearch/lite';


const algoliaClient = algoliasearch('PY4BD5F6JD', '3db26bfb121e0b734a2c0dbaa63f7568');


export const searchClient = {
  ...algoliaClient,
  async search(requests) {
      return await algoliaClient.search(requests)
  },
};

